import React, { useCallback } from 'react'
import VideoDuration from 'Components/video/video-duration'
import VideoSize from 'Components/video/video-size'
import VideoStats from 'Components/video/video-stats'
import formatDuration from 'lib/format-duration'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { Image, ImageStyles, ImageZoom } from 'Components/view-image'

interface IProps {
  order?: number
  className?: string
  title: string
  activeIndex?: number
  itemTeaParams?: any
  titleTeaParams?: any
  uniqueIdStr: string
  videoInfo: {
    coverUrl: string
    videoDuration: number
    videoWatchCount: number
    videoSize: string
  }
  column: {
    id?: number
    logo?: string
    name?: string
    introduction?: string
    description?: string
    episode?: number
    modify_time?: number
    publish_time: number
  }
  hasTop?: boolean
  onClickTitle?(): void
  onClickContent?(): void
  [key: string]: any
}

const Item: React.FC<IProps> = ({
  className,
  activeIndex,
  title,
  uniqueIdStr,
  videoInfo,
  column,
  itemTeaParams,
  titleTeaParams,
  order,
  hasTop = true,
  onClickTitle,
  onClickContent,
  ...props
}) => {
  const handleClick = useCallback(() => {
    if (itemTeaParams) {
      sendTeaCommEvent(
        'clk_event',
        Object.assign(itemTeaParams, {
          group_id: uniqueIdStr,
          rank: typeof activeIndex === 'number' ? `${activeIndex}` : '',
          item_rank: typeof order === 'number' ? `${order}` : '',
          section_id: `${column?.id}`,
          section_name: column?.name,
        })
      )
    }
    onClickContent && onClickContent()
  }, [uniqueIdStr, activeIndex, order, column?.id, column?.name])

  const handleTitleClick = useCallback(() => {
    if (titleTeaParams) {
      sendTeaCommEvent(
        'clk_event',
        Object.assign(titleTeaParams, {
          group_id: uniqueIdStr,
          rank: typeof activeIndex === 'number' ? `${activeIndex}` : '',
          item_rank: typeof order === 'number' ? `${order}` : '',
          section_id: `${column?.id}`,
          section_name: column?.name,
        })
      )
    }
    onClickTitle && onClickTitle()
  }, [uniqueIdStr, activeIndex, order, column?.id, column?.name])

  return (
    <div
      className={`orignal-create-item commont-card-item ${
        className ? className : ''
      }`}
      {...props}
      data-order={order}
    >
      {hasTop ? (
        <a
          className="info-top"
          target="_blank"
          href={`/video/groups/${column.id}`}
          onClick={handleTitleClick}
        >
          <div className="left-cover">
            <img
              className="cover"
              style={{ width: 44, height: 44 }}
              src={column?.logo}
            />
          </div>
          <div className="left-info">
            <div className="title-wrap">
              <div className="tt line-1 g-active-link-text">{column?.name}</div>
              <div className="periods g-active-link-text">
                共{column?.episode}期
              </div>
            </div>
            <div className="intro line-1 g-active-link-text">
              {column?.introduction}
            </div>
          </div>
        </a>
      ) : null}
      <div>
        <a
          className="image-wrap"
          target="_blank"
          href={`/article/${uniqueIdStr}`}
          onClick={handleClick}
        >
          <ImageZoom zoomHeight="56.25%">
            <Image
              src={videoInfo?.coverUrl}
              width={512}
              height={288}
              lazy={true}
              alt={title}
              className="motor-pc-image-hover"
            />
          </ImageZoom>
          <VideoSize
            sizeStr={videoInfo.videoSize}
            style={{ position: 'absolute', right: 70, bottom: 9 }}
          />
          <VideoDuration
            duration={formatDuration(videoInfo?.videoDuration)}
            style={{ position: 'absolute', right: 8, bottom: 8 }}
          />
        </a>
        <div className="info-bottom">
          <a
            className="desc line-2 g-active-link-text"
            target="_blank"
            href={`/article/${uniqueIdStr}`}
            onClick={handleClick}
            title={title}
          >
            {title}
          </a>
          <VideoStats
            playNums={videoInfo?.videoWatchCount}
            publishTime={column?.publish_time}
            postUnit="次播放"
          />
        </div>
      </div>
      <style jsx>
        {`
          .orignal-create-item {
            border-radius: 2px;
            position: relative;
            overflow: hidden;
            margin-bottom: 8px;
          }
          .orignal-create-item:last-child {
            margin-right: 0;
          }
          .image-wrap {
            line-height: 0;
            position: relative;
            border-bottom-left-radius: 2px;
            border-bottom-right-radius: 2px;
            overflow: hidden;
            display: block;
          }
          .info-top {
            display: flex;
            align-items: center;
            border-top-left-radius: 2px;
            border-top-right-radius: 2px;
            background-image: linear-gradient(103deg, #eceef4, #e1e4ee);
            padding: 8px;
          }
          .info-bottom {
            padding: 8px 8px 15px;
            cursor: pointer;
            position: relative;
          }
          .left-cover {
            width: 44px;
            margin-right: 8px;
            flex: 0 0 44px;
          }
          .cover {
            border-radius: 2px;
            border: solid 1px var(--color-gray-200);
            background: #000;
          }
          .left-info {
            flex: 1;
            overflow: hidden;
          }
          .title-wrap {
            display: flex;
          }
          .tt {
            flex: 1;
            font-size: 14px;
            font-weight: 500;
            color: #1f2129;
          }
          .periods {
            font-size: 14px;
            color: #606370;
          }
          .periods:after {
            content: '';
            width: 0;
            height: 0;
            top: -1px;
            position: relative;
            margin-left: 5px;
            display: inline-block;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
            border-left: 6px solid #606370;
          }
          .periods:hover:after {
            border-left: 6px solid #e65800;
          }
          .intro {
            font-size: 12px;
            height: 20px;
            color: #606370;
            margin-top: 5px;
          }
          .desc {
            font-family: PingFangSC;
            font-size: 16px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #1f2129;
          }
          .desc:after {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
          }
          .commont-card-item:hover .image-wrap {
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
          }
          .commont-card-item:hover .info-bottom {
            border-radius: 4px;
            background-color: #ffffff;
          }
        `}
      </style>
    </div>
  )
}

export default Item
